"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactSpinnerMaterial = _interopRequireDefault(require("react-spinner-material"));
var _styles = _interopRequireDefault(require("./styles.scss"));
var CLASS_KEY = 'spinner-wrapper';
var CLASS_NAME = _styles.default[CLASS_KEY] || CLASS_KEY;
var Spinner = function Spinner(props) {
  var className = props.className,
    show = props.show,
    color = props.color,
    stroke = props.stroke,
    radius = props.radius,
    spinnerLoadingLabel = props.spinnerLoadingLabel;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(className, " ").concat(CLASS_NAME)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "spinner-container"
  }, /*#__PURE__*/_react.default.createElement(_reactSpinnerMaterial.default, {
    radius: radius,
    color: color,
    stroke: stroke,
    visible: show
  }), spinnerLoadingLabel && /*#__PURE__*/_react.default.createElement("span", {
    className: "spinner-label"
  }, spinnerLoadingLabel)));
};
Spinner.propTypes = {
  className: _propTypes.default.string,
  show: _propTypes.default.bool,
  radius: _propTypes.default.number,
  stroke: _propTypes.default.number,
  color: _propTypes.default.string,
  spinnerLoadingLabel: _propTypes.default.string
};
Spinner.defaultProps = {
  className: '',
  show: true,
  radius: 100,
  stroke: 2,
  color: '#0099db',
  spinnerLoadingLabel: null
};
var _default = Spinner;
exports.default = _default;